import {BaseModel} from "../baseModel";
import {IsEnum, IsOptional, MaxLength, ValidateNested} from "class-validator";
import {UserSettingKey} from "../../enums/userSettingKey.enum";
import {UserProfile} from "../userProfile/userProfile.model";

class UserSetting extends BaseModel {
    userProfileId: number;

    @IsOptional()
    @ValidateNested()
    user?: UserProfile;

    @IsEnum(UserSettingKey)
    key: UserSettingKey;

    @MaxLength(255)
    value: string;
}

export {UserSetting}